import { takeEvery, all, put, call } from 'redux-saga/effects';
import { getSettingsSuccess, getSettingsFailed, GET_SETTINGS } from './settings.actions';
import { getSettings } from './settings.api';

function* getSettingsSaga(): any {
	try {
		const settings = yield call(getSettings);

		// Ensure a string is stored even if the value is undefined
		localStorage.setItem('casebookApiBaseURL', settings.casebookApiBaseURL || '');

		yield put(getSettingsSuccess(settings));
	} catch (error: any) {
		yield put(getSettingsFailed(error.message));
	}
}

function* getSettingsWatcher() {
	yield takeEvery(GET_SETTINGS, getSettingsSaga);
}

export default function* settingsSaga() {
	yield all([getSettingsWatcher()])
}